/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationDestroy } from '../../axios/organisationDestroy'
import type {
	OrganisationDestroyError,
	OrganisationDestroyPathParams,
	OrganisationDestroyResponse,
} from '../../types/OrganisationDestroy'

export const organisationDestroyMutationKey = () => [{ url: '/organisations/:organisation' }] as const

export type OrganisationDestroyMutationKey = ReturnType<typeof organisationDestroyMutationKey>

export type OrganisationDestroyVariables = {
	organisation: OrganisationDestroyPathParams['organisation']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::destroy */
export function useOrganisationDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationDestroyResponse,
		AxiosError<OrganisationDestroyError>,
		OrganisationDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationDestroyMutationKey(),
		mutationFn: ({ organisation }: OrganisationDestroyVariables) =>
			organisationDestroy(organisation, config).then(res => res.data),
		...options,
	})
}
